import { FileUpload } from 'components/Forms/InvitationForm/fileUpload';
import { types, Instance } from 'mobx-state-tree';
const { string, model, maybeNull, maybe, array, integer } = types;

export const AdminProfileInfoModel = model('AdminProfileInfoModel', {
  address: maybeNull(string),
  password: maybeNull(string),
  profileUrl: maybe(string),
  confirm_password: maybeNull(string),
  oldPassword: maybeNull(string),
  billingContactInformationDepartment: maybeNull(string),
  billingContactInformationEmail: string,
  billingContactInformationFullName: string,
  billingContactInformationPhone: maybeNull(string),
  billingContactInformationTitle: maybeNull(string),
  department: maybeNull(string),
  profileImg: maybe(FileUpload),
  email: string,
  firstName: string,
  lastName: maybeNull(string),
  lastLogin: maybeNull(string),
  organizationName: maybeNull(string),
  phone: maybeNull(string),
  salesTaxGstVatExemptOrganization: integer,
  title: maybeNull(string),
});

export type IAdminProfileInfoModel = Instance<typeof AdminProfileInfoModel>;

export const AdminPasswordInfoModel = model('AdminPasswordInfoModel', {
  password: maybeNull(string),
  password_confirmation: maybeNull(string),
  current_password: maybeNull(string),
});
export type IAdminPasswordInfoModel = Instance<typeof AdminPasswordInfoModel>;

export const ClientActivationModel = model('ClientActivationModel', {
  EC2AWSRegion: array(string),
  defaultDomain: maybeNull(string),
  defaultRegion: maybeNull(string),
});
export type IClientActivationModel = Instance<typeof ClientActivationModel>;
